<div layout layout-vertical>
  <div class="change-password-wrap" layout layout-vertical margin-bottom>
    <rt-heading variant="heading" margin-bottom-small-x
      >{{ 'tlc.current_user.admin_password_form.heading' | translate }}
    </rt-heading>
    <div layout>
      <rt-button (click)="resetPassword()" variant="outline">
        <rt-icon name="vpn-key" />
        <span>{{ 'tlc.current_user.admin_password_form.change_password' | translate }}</span>
      </rt-button>
    </div>
  </div>

  @if (canChangePasswordRecoveryEmail()) {
    <div class="password-recovery-wrap" layout layout-vertical margin-bottom>
      <rt-heading variant="heading"
        >{{ 'tlc.current_user.password_recovery_email.heading' | translate }}
      </rt-heading>
      @if (hasRecoveryEmail()) {
        {{ currentUser()?.recoveryEmail }}
      } @else {
        <span>
          {{ 'tlc.current_user.password_recovery_email.description' | translate }}
        </span>
      }

      <div layout margin-top-small-x>
        @if (!hasRecoveryEmail()) {
          <rt-button (click)="openPasswordEmailRecoverySettings()" variant="outline">
            <rt-icon name="add" />
            <span>{{
              'tlc.current_user.password_recovery_email.add_recovery_email' | translate
            }}</span>
          </rt-button>
        } @else {
          <rt-button (click)="openPasswordEmailRecoverySettings()" variant="outline">
            <rt-icon name="edit" />
            <span>{{
              'tlc.current_user.password_recovery_email.change_recovery_email' | translate
            }}</span>
          </rt-button>
        }
      </div>
    </div>
  }

  <div class="two-fa-wrap" margin-bottom>
    <div layout layout-vertical>
      <rt-heading variant="heading"> {{ 'tlc.current_user.2fa.heading' | translate }}</rt-heading>
      <span>
        {{ 'tlc.current_user.2fa.description' | translate }}
        <a [href]="'tlc.help_articles.2fa_help_article' | translate" target="_blank" class="link">{{
          'tlc.current_user.2fa.link_label' | translate
        }}</a>
      </span>
    </div>

    @if (!!data()) {
      <div layout layout-vertical margin-bottom-small>
        @if (canEnable2fa) {
          <rt-infobox [isDismissible]="false" [iconName]="'info-outline'" margin-top>
            {{ 'tlc.current_user.2fa.infobox' | translate }}
          </rt-infobox>
        } @else {
          <rt-infobox
            [isDismissible]="false"
            [iconName]="'info-outline'"
            [heading]="'tlc.current_user.2fa.no_access_infobox.heading' | translate"
            margin-top
          >
            <!-- TODO Add link to plan picker-->
            <div
              [innerHTML]="
                'tlc.current_user.2fa.no_access_infobox.description' | translate: { link: '#' }
              "
            ></div>
          </rt-infobox>
        }
      </div>
      <div class="providers-list" layout-full-width>
        <rt-provider-item
          [status]="data()?.smsEnabled ? 'connected' : 'inactive'"
          [header]="'tlc.current_user.2fa.provider.sms_heading' | translate"
          [description]="'tlc.current_user.2fa.provider.sms_description' | translate"
          [icon]="'sms'"
          margin-bottom-small
        >
          @if (canEnable2fa) {
            <ng-container
              *ngTemplateOutlet="
                data()?.smsEnabled ? actionTemplate : activateButton;
                context: { provider: providers.Sms }
              "
            />
          }
        </rt-provider-item>

        <rt-provider-item
          [status]="data()?.appEnabled ? 'connected' : 'inactive'"
          [header]="'tlc.current_user.2fa.provider.app_heading' | translate"
          [description]="'tlc.current_user.2fa.provider.app_description' | translate"
          [icon]="'security'"
        >
          @if (canEnable2fa) {
            <ng-container
              *ngTemplateOutlet="
                data()?.appEnabled ? actionTemplate : activateButton;
                context: { provider: providers.App }
              "
            />
          }
        </rt-provider-item>
      </div>
    } @else {
      <rt-placeloader margin-bottom-small [variant]="'item'" />
      <rt-placeloader margin-bottom-small [variant]="'item'" />
      <rt-placeloader [variant]="'item'" />
    }
  </div>

  @if (currentMembership()) {
    <div class="grant-access-wrap" layout layout-vertical>
      <rt-heading variant="heading" margin-bottom-small-x>{{
        'tlc.current_user.grant_access.heading' | translate
      }}</rt-heading>
      <span margin-bottom-small
        >{{ 'tlc.current_user.grant_access.description' | translate }}
        <a [href]="'tlc.help_articles.grant_access' | translate" target="_blank" class="link">{{
          'tlc.current_user.grant_access.link_label' | translate
        }}</a></span
      >
      <div layout layout-vertical>
        @if (isAccessGranted()) {
          <rt-button class="grant-access-button" [variant]="'error'" (click)="revokeAccess()">
            <span>{{ 'tlc.current_user.grant_access.access_button.revoke' | translate }}</span>
          </rt-button>
        } @else {
          <rt-button class="grant-access-button" [variant]="'outline'" (click)="grantAccess()">
            <span>{{ 'tlc.current_user.grant_access.access_button.grant' | translate }}</span>

            <rt-icon name="keyboard-arrow-right" />
          </rt-button>
        }

        <ng-container
          *ngTemplateOutlet="rows().length ? accessTable : null; context: { accessData }"
        />
      </div>
    </div>
  }

  <div class="delete-account-wrap" layout layout-vertical margin-top>
    <rt-heading variant="heading" margin-bottom-small-x>{{
      'tlc.current_user.delete_account.heading' | translate
    }}</rt-heading>
    <span margin-bottom-small
      >{{ 'tlc.current_user.delete_account.description' | translate }}
    </span>

    <rt-button class="delete-button" variant="outline" (click)="deleteAccount()">
      <span>{{ 'tlc.current_user.delete_account.button' | translate }}</span>
    </rt-button>
  </div>

  <ng-template #accessTable let-accessData="accessData">
    <rt-divider margin-tb />
    <tlc-approval-history-table
      [rows]="rows()"
      [pagination]="pagination()"
      (pageChange)="onPageChanged($event)"
    />
  </ng-template>

  <ng-template #actionTemplate let-provider="provider">
    <div class="active" layout layout-align-items-center text-primary text-bold>
      <rt-icon name="check" margin-right-small-x colorToken="colorIconPrimaryDefault" />
      {{ 'tlc.current_user.2fa.provider_active' | translate }}
    </div>
    <rt-icon-button
      (click)="moreDropdown.open = true"
      [pressed]="moreDropdown.open"
      #moreDropdownTrigger="rtOverlayOrigin"
      variant="plain"
      iconName="more-horiz"
      margin-left-small
      rt-overlay-origin
    />
    <ng-template
      #moreDropdown="rtConnectedOverlay"
      [origin]="moreDropdownTrigger"
      (backdropClick)="moreDropdown.open = false"
      rt-connected-overlay
      hasBackdrop
    >
      <rt-dropdown [width]="DropdownWidth.SmallX">
        <rt-dropdown-item (click)="disable2FactorAuth(provider)"
          ><rt-icon prefix name="remove-circle" />
          {{ 'tlc.current_user.2fa.provider.deactivate' | translate }}
        </rt-dropdown-item>
      </rt-dropdown>
    </ng-template>
  </ng-template>

  <ng-template #activateButton let-provider="provider">
    <rt-button
      (click)="
        provider === providers.Sms
          ? openSms2FactorActivationDialog()
          : openApp2FactorActivationDialog()
      "
      variant="outline"
      margin-left-small
    >
      {{ 'tlc.current_user.2fa.provider.activate' | translate }}
    </rt-button>
  </ng-template>
</div>
@if (isNativeMobile) {
  <div class="bottom-spacer"></div>
}
